import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { PaymentElement } from '@stripe/react-stripe-js';

import { BodyText, DisplayText, theme } from '@sg/garnish';

import { type StripePaymentElementProps } from '../../types';

// ────────────────────────────────────────────────────────────────────────────

export const StripePaymentElement = (props: StripePaymentElementProps) => {
  const { hasStripeFailedToLoad, children, show } = props;

  return (
    <View style={[styles.container, show ? null : styles.hide]}>
      <DisplayText sizeMatch={['32']}>
        <FormattedMessage {...messages.title} />
      </DisplayText>

      {hasStripeFailedToLoad ? (
        <BodyText style={styles.failure} sizeMatch={['20']}>
          <FormattedMessage {...messages.stripeFailedToLoad} />
        </BodyText>
      ) : (
        <PaymentElement />
      )}

      {children}
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: theme.spacing['4'],
    paddingTop: theme.spacing['20'],
    paddingBottom: theme.spacing['10'],
    gap: theme.spacing['4'],
  },
  hide: {
    maxHeight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  failure: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Select payment option',
    description: 'Stripe Payment Element | Title',
  },
  stripeFailedToLoad: {
    defaultMessage:
      'Something went wrong while loading the payment provider. Please refresh the page.',
    description: 'Stripe Payment Element | Stripe failed to load',
  },
});
